import { useEffect, useRef, useState } from 'react';
import { useParams } from "react-router-dom";
import { RichiestaService } from "../../../services/RichiestaService";
import Step2 from './Step2/Step2';
import Step4IscrizioneScolastica from './step4/Step4IscrizioneScolastica';
import Step1 from './Step1/Step1';
import Timeline from '../../Utility/Timeline/Timeline';
import Step3 from './Step3/Step3';
import Step5 from './Step5/Step5';
import Step6 from './Step6/Step6';
import { NazioneService } from '../../../services/NazioneService';
import Step4IscrizioneScolasticaRipresentazione from './step4Ripresentazione/Step4IscrizioneScolasticaRipresentazione';
import { tipologieFase } from '../../../constants/TipologiaFase';
import Step6Ripresentazione from './Step6Ripresentazione/Step6Ripresentazione';

const GestioneRichiesta = () => {    
  const {id} = useParams();
  const [selectedTab, setSelectedTab] = useState(0);
  const [richiesta, setRichiesta] = useState(null);

  const [nations, setNations] = useState(null);

  const [comuniRichiedente, setComuniRichiedente] = useState([]);

  const [steps, setSteps] = useState([
    { index: 1, label: "Dati del richiedente", completed: true },
    { index: 2, label: "Rapporto col beneficiario", completed: false },
    { index: 3, label: "Dati del beneficiario", completed: false },
    { index: 4, label: "Dati sull'iscrizione scolastica", completed: false },
    { index: 5, label: "Dati ISEE e di pagamento", completed: false },
    { index: 6, label: "Riepilogo", completed: false }
  ]);

  const scrollRef = useRef(null);

  const nazioneService = new NazioneService();
  const richiestaService = new RichiestaService();

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, [richiesta]);

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }, [selectedTab]);

  const gotoStep = (index, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setSelectedTab(index);
  };

  const getRichiesta = async() => {
    if (!id) return;
    const resp = await richiestaService.get(id);
    setRichiesta(resp);
    updateStepCompletati(resp);

    setSteps([ ...steps ]);
  }

  const updateStepCompletati = (richiesta) => {
    steps.forEach(step => {
      switch (step.index) {
        case 1:
          step.completed = !!richiesta.richiestaDatiRichiedente;
          break;
        case 2:
          step.completed = !!richiesta?.richiestaRapportoBeneficiario;
          break;
        case 3:
          step.completed = !!richiesta.richiestaDatiBeneficiario?.completato;
          break;
        case 4:
          step.completed = !!richiesta.richiestaIscrizioneScolastica;
          break;
        case 5:
          step.completed = !!richiesta.richiestaDatiPagamento;
          break;
        case 6:
          step.completed = richiesta.statoRichiesta === 'PRESENTATA';
          break;
        default:
          break;
      }
    });
  }

  const updateSpecificStep = (stepIndex, value) => {
    setSteps((prevSteps) =>
      prevSteps.map((step) =>
        step.index === stepIndex ? { ...step, completed: value } : step
      )
    );
  }

  const afterStepSubmit = (r) => {
    console.log('afterStepSubmit');
    setRichiesta({...r});
    updateStepCompletati(r);
  }

  useEffect(() => {
    getRichiesta();
    nazioneService.getAll().then(resp => {
      let nations = [...resp];
      const italia = nations.find((nazione) => nazione.nome === "Italia");
      nations.sort((a, b) => a.cittadinanza.localeCompare(b.cittadinanza));
      nations = nations.filter((nazione) => nazione.nome !== "Italia");
      nations.unshift(italia);
      setNations(nations);
    });
  }, []);

  const renderStep = (index) => {
    if (!richiesta) return;

    switch (index) {
      case 0:
        return <Step1
									nextBtnFunction={() => gotoStep(index + 1)}
									richiesta={richiesta}
                  afterSubmitFunction={afterStepSubmit}
                  onChangedValue={() => updateSpecificStep(index + 1, false)}
                  propagateComuni={(comuni) => setComuniRichiedente(comuni)}
                  nazioni={nations}
								/>;
      case 1:
        return <Step2
                  previousBtnFunction={() => gotoStep(index - 1)}
                  nextBtnFunction={() => gotoStep(index + 1)}
                  richiesta={richiesta}
                  afterSubmitFunction={afterStepSubmit}
                  onChangedValue={() => updateSpecificStep(index + 1, false)}        
                />;
      case 2:
        return <Step3
                  previousBtnFunction={() => gotoStep(index - 1)}
                  nextBtnFunction={() => gotoStep(index + 1)}
                  richiesta={richiesta}
                  afterSubmitFunction={afterStepSubmit}
                  onChangedValue={() => updateSpecificStep(index + 1, false)}
                  comuniRichiedente={comuniRichiedente}
                  nazioni={nations}
                />;
      case 3:
        return richiesta.fase.tipologia === tipologieFase.riapertura_presentazione
                  ? <Step4IscrizioneScolasticaRipresentazione
                      previousBtnFunction={() => gotoStep(index - 1)}
                      nextBtnFunction={() => gotoStep(index + 1)}
                      richiesta={richiesta}
                      afterSubmitFunction={afterStepSubmit}
                      onChangedValue={() => updateSpecificStep(index + 1, false)}
                      nazioni={nations}
                    />
                  : <Step4IscrizioneScolastica
                      previousBtnFunction={() => gotoStep(index - 1)}
                      nextBtnFunction={() => gotoStep(index + 1)}
                      richiesta={richiesta}
                      afterSubmitFunction={afterStepSubmit}
                      onChangedValue={() => updateSpecificStep(index + 1, false)}
                      nazioni={nations}
                    />;
      case 4:
        return <Step5
                  previousBtnFunction={() => gotoStep(index - 1)}
                  nextBtnFunction={() => gotoStep(index + 1)}
                  richiesta={richiesta}
                  afterSubmitFunction={afterStepSubmit}
                  onChangedValue={() => updateSpecificStep(index + 1, false)}
                />;
      case 5:
        return richiesta.fase.tipologia === tipologieFase.riapertura_presentazione
                  ? <Step6Ripresentazione
                      richiesta={richiesta}
                      previousBtnFunction={() => gotoStep(index - 1)}
                      afterSubmitFunction={afterStepSubmit}
                      nazioni={nations}
                    />
                  : <Step6
                      richiesta={richiesta}
                      previousBtnFunction={() => gotoStep(index - 1)}
                      afterSubmitFunction={afterStepSubmit}
                      nazioni={nations}
                    />;
      default:
        return <>
          <p>{index}</p>
          {index > 0 && (
            <button onClick={() => gotoStep(index - 1)} className="rtds-btn rtds-btn--only-text">
              Indietro
            </button>
          )}
          {index < steps.length - 1 && (
            <button onClick={() => gotoStep(index + 1)} className="rtds-btn rtds-btn--only-text">
              Vai avanti
            </button>
          )}
        </>;
    }
  }

  return (
    <>
      <section className="rtds-grid rtds-gap-4" hidden={richiesta}>
        <div
          className="rtds-empty-state rtds-grid rtds-gap-4"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
            <svg
              className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-animate-spin"
              aria-hidden="true"
              focusable="false"
              role="img"
            >
              <use 
               xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
              />
            </svg>
            <span className="rtds-sr-only">Caricamento...</span>

            <h3 className="rtds-heading-4">
              <div className="loading-message">
                Attendere un momento
                <span className="dots">...</span>
              </div>
            </h3>
          </div>
        </div>
      </section>

      <div
        className="rtds-container rtds-my-12"
        hidden={!richiesta}
        ref={scrollRef}
      >

         {richiesta?.canBeSaved && (
        <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
          {/* <div className="rtds-flex rtds-items-center rtds-justify-between" hidden={richiesta?.statoRichiesta !== 'PRESENTATA'}>
          <h1 className="rtds-heading-2" id="tablist-1">Domanda <span className="rtds-content-02">{richiesta?.codice}</span></h1>
        </div> */}
         
            <Timeline steps={steps} currentStep={selectedTab} />
        
        </div>
          )}

        {richiesta && !richiesta?.canBeSaved && (
          <div
            key={5}
            hidden={false}
            id={`tabpanel-5`}
            className="rtds-tablist__tabpanel"
            role="tabpanel"
            aria-labelledby={`tab-5`}
          >
            {renderStep(5)}
          </div>
        )}

        {richiesta?.canBeSaved &&
          steps.map((step, index) => (
            <div
              key={index}
              hidden={selectedTab !== index}
              id={`tabpanel-${index}`}
              className="rtds-tablist__tabpanel"
              role="tabpanel"
              aria-labelledby={`tab-${index}`}
            >
              {renderStep(index)}
            </div>
          ))}
      </div>
    </>
  );
};

export default GestioneRichiesta;
